import React from 'react';

const PropertyDetailsSection = ({ isTenantExist }) => (
    <div style={{ alignItems: "center" }} className='d-flex'>
        <h3 className='fs-4'>Property Address:</h3>
        <div className='px-2'>{isTenantExist?.PropertyAddress}</div>
    </div>
);

export default PropertyDetailsSection;
